import yup from '../../../config/yup';

export const stopValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('stop'),
  action: yup.string().default('STOP').required('Action is required'),
  command: yup
    .string()
    .default('STOP')
    .required('Command is required')
    .matches(/^STOP\s+\S+/i, "Command must start with 'STOP' followed by at least one word"),
});
